var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "content-panel",
    attrs: {
      "id": "klienti-window"
    },
    on: {
      "scroll": function scroll($event) {
        return _vm.paginationCheck($event);
      }
    }
  }, [_c('div', {
    staticClass: "statistics"
  }, [_c('div', {
    staticClass: "stat-bar-filter"
  }, [_c('div', {
    staticClass: "filter-flex-custom"
  }, [_c('klienti-filters-bar', {
    ref: "filters"
  }), _c('div', {
    staticClass: "clients-toolbar-actions"
  }, [_vm.$store.getters['userState/getRole'] === 'financnik' ? _c('router-link', {
    staticClass: "toolbar-action",
    attrs: {
      "to": "/marketing/"
    }
  }, [_vm._v("Kampane a kontakty")]) : _vm._e(), _c('button', {
    staticClass: "toolbar-action",
    attrs: {
      "type": "button",
      "title": "Vymazať filtre"
    },
    on: {
      "click": _vm.resetFilters
    }
  }, [_c('img', {
    attrs: {
      "src": require("@/images/reset-circular.svg"),
      "alt": ""
    }
  }), _c('span', [_vm._v("Reset")])]), _c('button', {
    staticClass: "toolbar-action",
    "class": {
      'is-active': _vm.statsShown
    },
    attrs: {
      "type": "button",
      "aria-expanded": _vm.statsShown ? 'true' : 'false',
      "title": "Zobraziť štatistiky"
    },
    on: {
      "click": _vm.toggleStats
    }
  }, [_c('svg', {
    staticClass: "statistic-icon",
    attrs: {
      "width": "25",
      "height": "25",
      "viewBox": "0 2 15 13",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M0.875 0.875V10.875C0.875 11.5582 1.44184 12.125 2.125 12.125H12.125V10.875H2.125V0.875H0.875ZM11.0752 2.94653L8.36768 5.62842L6.49634 3.83887L2.93921 7.302L3.81079 8.198L6.50366 5.57593L8.38232 7.37158L11.9553 3.83398L11.0752 2.94653Z",
      "fill": "white"
    }
  })]), _c('span', [_vm._v("Štatistiky")])])], 1)], 1), _vm.statsShown ? _c('klienti-stats') : _vm._e()], 1)]), _c('klienti-item-wrapper', {
    on: {
      "pagination-check": _vm.paginationCheck,
      "reset-pagination": function resetPagination($event) {
        _vm.paginationLoading = false;
      },
      "select-tab": function selectTab($event) {
        _vm.activeTab = $event;
      }
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }